import React from "react";

export default function ZoneOverview(props) {
  return <div>{props.children}</div>;
}
